// 引入组件
import headComponent from "components/content/Head";	// header
import footComponent from "components/content/Foot";	// footer


export default {
	headComponent,
  	footComponent
}
